module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/portal/packages/core-app/src/templates/menuView-context.html -->\n<ul class="mdc-list " role="menu" aria-hidden="true" aria-orientation="vertical">\n	<a href="{{route}}" class="mdc-list-item mdc-ripple-surface mdc-ripple-surface--primary nx-action" data-action="{{action}}" tabindex="-1">\n		<span class="mdc-list-item__graphic" aria-hidden="true">{{icon}}</span>\n		<span class="mdc-list-item__text">{{label}}</span>\n	</a>\n</ul>\n';
}
return __p;
};
